import React from 'react';
import GetInvolvedHeader from '../components/ServicesComponents/GetInvolvedHeader';
import CallToAction from '../components/Misc/CallToAction';
import TextContent from '../components/TextContent/TextContent';
import Heading from '../components/Headers/Heading';
import ServiceBox from '../components/ServicesComponents/ServiceBox';
import { VolunteerForm } from '../components/Forms/VolunteerForm.js';
import { ServicesData } from '../Data/ServicesData';

function ServicesStyle1() {
    return (
        <>
            <GetInvolvedHeader />
            <div className="services-section">
                <div className="services-section-wrapper">
                    <div className="container">
                        <Heading 
                            heading={<h1>Volunteer roles</h1>}
                            headingClass="heading-very-large dark-1"
                            headingColumn="col-lg-6"
                            paragraph="Join our compassionate team to support underserved communities with mental health, medical care, and psychosocial services. Your skills can help save lives and restore hope!"
                            paragraphClass="dark-2"
                            paragraphColumn="col-lg-6"
                        />
                        <div className="row service-withoutimage">
                            {[
                                { title: "Counselors", icon: ServicesData[0].icon },
                                { title: "Psychologists", icon: ServicesData[1].icon },
                                { title: "Nurses", icon: ServicesData[3].icon },
                                { title: "Psychiatrists", icon: ServicesData[4].icon },
                                { title: "Social Workers", icon: ServicesData[5].icon },
                                { title: "Pharmacists", icon: ServicesData[6].icon },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <div className="col-lg-4">
                                        <ServiceBox title={item.title} icon={item.icon} />
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                        {/* Application Form for Get Involved */}
                        <div className="application-form-section">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8 mx-auto">
                                        <div className="contact-form-wrapper">
                                            <VolunteerForm />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TextContent />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default ServicesStyle1;
